import {Basic} from "./Basic";
import {Browser} from "./Browser";
import {Display} from "./Display";
import {History} from "./History";
import {Slider} from "./Slider";

window.addEventListener('DOMContentLoaded',function()
{
    // set variables
    Basic.init();

    // get environment
    Browser.analyze();
    Display.analyze();

    // get language from HTML
    Basic.lang = document.documentElement.lang;

    // remove hover class on mobile devices
    if(Browser.mobile === true)
    {
        document.body.classList.remove('hover');
    }
    else
    {
        // add event listeners
        Basic.add_mouseMoveEvent();
    }

    // add class video-p to paragraphs around videos
    const videos = document.body.querySelectorAll('.w__video--placeholder');
    videos.forEach(el => {
        const p = el.closest('p');
        p.classList.add('video-p');
    });

    // fade out chronicle paragraphs
    Basic.chronicles.forEach(el => {
        el.classList.add('faded');
    });

    // check experiment conditions
    const myExperimentButton = document.body.querySelector('.experiment-button');
    if(myExperimentButton)
    {
        if(Browser.mobile === true)
        {
            myExperimentButton.textContent = (Basic.lang === 'de')
                ? "Bitte nutzen Sie einen Computer für ein optimales Erlebnis"
                : "Please use a computer for an optimal experience";
            myExperimentButton.removeAttribute('href');
        }
    }

    // activate sliders
    const mySliders = document.body.querySelectorAll('.slider-move');
    for(let i=0; i<mySliders.length; i++)
    {
        Basic.sliders[i] = new Slider(mySliders[i], i);
    }

    // add event listeners
    Basic.add_clickEvent();
    History.add_event();

    // replace first history element
    History.replace_url(0);
});

window.addEventListener('load',function()
{
    // set initial parallax
    /*
    const parallaxed = document.body.querySelectorAll('.parallaxed2');

    parallaxed.forEach(el =>
    {
        if(!el.classList.contains('do-not-adjust'))
        {
            el.style.marginBottom = Math.round(el.getBoundingClientRect()['height'] / -2).toString() + 'px';
        }
        el.style.top = Math.round(el.getBoundingClientRect()['top'] / Basic.parallaxFactor * -1).toString() + 'px';
    });
     */

    // set anchor menu sticky
    const anchorMenu = document.getElementById('anchor-menu');
    if(anchorMenu &&
        Browser.mobile === false &&
        Display.device !== 'smartphone')
    {
        anchorMenu.dataset.posY = Math.floor(anchorMenu.getBoundingClientRect()['top'] + window.scrollY).toString();
        anchorMenu.classList.add('sticky');
        anchorMenu.querySelector('.anchor-menu').addEventListener('mouseenter',() =>
        {
            anchorMenu.classList.remove('out');
        });
    }

    // call process_scroll
    Basic.process_scroll();
});

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(Basic.resizeTimer);
    Basic.resizeTimer = requestAnimationFrame(Basic.process_resize);
});

// window resize detection
window.addEventListener('scroll',() =>
{
    cancelAnimationFrame(Basic.scrollTimer);
    Basic.scrollTimer = requestAnimationFrame(Basic.process_scroll);
});